import axios from 'axios'
import Noty from 'noty';
import moment from 'moment'
import 'moment-timezone';
// import WebPushService from './WebPushService';

var http = null
var baseURL = null

class WebService {
    constructor({}) {
        baseURL = process.env.BASE_URL
        http = axios.create({
                baseURL: process.env.BASE_URL
            })
            // this.getConfig();
            // this.setSessionTime();
    }


    getAPI({ _action, _body, _buttonId, _hide_loader }) {
        let params = new URLSearchParams()
        for (let key in _body) {
            params.set(key, _body[key])
        }

        if (this.addLoader(_buttonId, _hide_loader)) {
            return
        }

        return http
            .get(_action, {
                params: params,
                headers: this.getHeader()
            })
            .then(response => {
                this.removeLoader(_buttonId, _hide_loader)
                return response.data
            })
            .catch(e => {
                this.removeLoader(_buttonId, _hide_loader)
                return this._errorHandler(e)
            })
    }

    postAPI({ _action, _body, _buttonId, _hide_loader, _hide_error }) {
        if (this.addLoader(_buttonId, _hide_loader)) {
            return
        }

        return http
            .post(_action, JSON.stringify(_body), { headers: this.getHeader() })
            .then(response => {
                this.removeLoader(_buttonId, _hide_loader)
                return response.data
            })
            .catch(e => {
                this.removeLoader(_buttonId, _hide_loader)
                return this._errorHandler(e, _hide_error)
            })
    }

    putAPI({ _action, _body, _buttonId, _hide_loader }) {
        if (this.addLoader(_buttonId, _hide_loader)) {
            return
        }
        return http
            .put(_action, JSON.stringify(_body), { headers: this.getHeader() })
            .then(response => {
                this.removeLoader(_buttonId, _hide_loader)
                return response.data
            })
            .catch(e => {
                this.removeLoader(_buttonId, _hide_loader)
                return this._errorHandler(e)
            })
    }

    deleteAPI({ _action, _buttonId, _hide_loader }) {
        if (this.addLoader(_buttonId, _hide_loader)) {
            return
        }
        return http
            .delete(_action, { headers: this.getHeader() })
            .then(response => {
                this.removeLoader(_buttonId, _hide_loader)
                return response.data
            })
            .catch(e => {
                this.removeLoader(_buttonId, _hide_loader)
                return this._errorHandler(e)
            })
    }


    uploadImageAPI({ _action, _file, _key, _body, _buttonId, _hide_loader }) {
        if (!_key) {
            _key = 'file'
        }
        if (this.addLoader(_buttonId, _hide_loader)) {
            return
        }
        let formData = new FormData()
        formData.append(_key, _file)
        for (let key in _body) {
            formData.append(key, _body[key])
        }

        return http
            .post(_action, formData, { headers: this.addHeaderForMultipart() })
            .then(response => {
                this.removeLoader(_buttonId, _hide_loader)
                return response.data
            })
            .catch(e => {
                this.removeLoader(_buttonId, _hide_loader)
                return this._errorHandler(e)
            })
    }

    getAccesstoken({ _action, _body, _buttonId, _hide_loader }) {
        if (this.addLoader(_buttonId, _hide_loader)) {
            return
        }
        var headers = {}

        headers['Content-Type'] = 'application/json'

        return http
            .post(_action, JSON.stringify(_body), null, { headers: headers })
            .then(response => {
                localStorage.setItem('access_token', response.data.access_token)
                this.removeLoader(_buttonId, _hide_loader)
                return response.data
            })
            .catch(e => {
                this.removeLoader(_buttonId, _hide_loader)
                return this._loginErrorHandler(e)
            })

    }

    _loginErrorHandler(error) {
        if (error.response != null) {
            error = error.response
        }
        var errorMessage
        if (!error || !error.status) {
            errorMessage = 'Server Not Responding'
        } else if (error.status === 400 || error.status === 404) {
            errorMessage =
                (error && error.data && error.data.message) ||
                'Invalid Username or Password'
        } else if (error.status === 500) {
            errorMessage = 'Server Error'
        } else {
            errorMessage =
                (error & error.data && error.data.message) || 'Bad Response'
        }
        new Noty({
            type: 'error',
            text: errorMessage,
            timeout: 2000
        }).show()
        throw new Error(errorMessage)
    }
    _errorHandler(error) {
        if (error.response != null) {
            error = error.response
        }
        var errorMessage
        if (!error || !error.status) {
            errorMessage = 'Server Not Responding'
        } else if (error.status === 401) {
            errorMessage =
                (error && error.data && error.data.message) || 'Bad Response'
            this.logout()
        } else if (error.status === 500) {
            errorMessage = 'Server Error'
        } else {
            errorMessage =
                (error && error.data && error.data.message) || 'Bad Response'
        }

        new Noty({
            type: 'error',
            text: errorMessage,
            timeout: 2000
        }).show()
        throw new Error(errorMessage)
    }

    logout() {
        localStorage.clear()
        this.$shareService.clearMap()
        window.location.href = '/login'
    }

    getHeader() {
        var headers = {}
        headers['Content-Type'] = 'application/json'
        if (localStorage.getItem('access_token')) {
            headers['Authorization'] = 'Bearer ' + localStorage.getItem('access_token')
        }
        return headers
    }

    addHeaderForMultipart() {
        if (localStorage.getItem('access_token')) {
            var headers = {}
            if (localStorage.getItem('access_token')) {
                headers['Authorization'] =
                    'Bearer ' + localStorage.getItem('access_token')
            }
            return headers
        } else {
            // logout app
        }
    }

    addLoader(id, _hide_loader) {
        if (id) {
            var button = document.getElementById(id)
            if (button.disabled) {
                return true
            }
            button.disabled = true
            var loader = document.createElement('i')
            loader.className = 'fa fa-spinner fa-spin mr-2'
            button.prepend(loader)
            return false
        }
    }

    getBaseUrl() {
        return baseURL
    }

    getServerUrl() {
        return process.env.APP_URL;
    }

    removeLoader(id, _hide_loader) {
        if (id && !_hide_loader) {
            var button = document.getElementById(id)
            button.disabled = false
            button.removeChild(button.childNodes[0])
        }
    }
    allowCharater(e) {
        if (
            (e.charCode > 64 && e.charCode < 91) ||
            (e.charCode > 96 && e.charCode < 123) ||
            e.charCode == 32
        ) {
            return true;
        } else {
            e.preventDefault();
            return false;
        }
    }
    allowNumber(e) {
        if (!/\d/.test(e.key) && e.key !== '.') return e.preventDefault();
    }

}

export default new WebService({})


// WEBPACK FOOTER //
// ./src/services/Webservice.js